import { FormSubmitFunction } from "lib/form";
import { FormEvent, FunctionComponent } from "react";
import { FormProvider } from "react-hook-form";

interface FormProps {
  children: any;
  methods: any;
  identifier?: string;

  // for password systems
  dataFormType?: string;

  // on submit is always promise
  onSubmit: FormSubmitFunction;
}

// RULE: sub-form-elements should not fetch anything, they should
// only focus on showing the form grid and handling form validation etc.
// They will receive data needed for defaultValues and they will send
// the validated date to parent component.
const Form: FunctionComponent<FormProps> = ({
  children,
  methods,
  identifier,
  dataFormType,
  onSubmit,
}) => {
  const { handleSubmit, trigger } = methods;

  const submitter = (event: FormEvent<HTMLFormElement>) => {
    // validate all fields by force
    trigger(undefined);

    // catch form onSubmit event, make sure it doesn't propagate and then invoke the original onSubmit
    event.stopPropagation();
    event.preventDefault();
    return handleSubmit(onSubmit)(event);
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={submitter} data-form-type={dataFormType} id={identifier}>
        {children}
      </form>
    </FormProvider>
  );
};

export default Form;
